
export interface User {
  id: string;
  email: string;
  initials: string;
  displayName: string;
  mobile: string;
  avatarUrl?: string;
  isEmailVerified: boolean;
  notes: string;
  lastLogin: number;
}

export interface InterestedUserEntry {
  uid: string;
  name: string;
  email: string;
  stateCode: string;
  stateName: string;
  dateRegistered: Date; 
  interestedInBeta: boolean;
  emailSent?: boolean;
}

export const COLLECTION_PATH_INTERESTED_USERS = 'marketing_interested_users';